import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CloseRounded from "@mui/icons-material/CloseRounded";

/**
 * The Settings dialog's frame: title, close button, full screen on phones. Shared by the
 * account menu's SettingsDialog and the signed-out PublicSettingsButton, which must not
 * load the account Settings (and Firebase with it) just to change the language.
 */
const SettingsDialogShell = ({ open, onClose, maxWidth = "md", children }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={maxWidth}
      scroll="paper"
      aria-labelledby="settings-dialog-title"
    >
      <DialogTitle
        id="settings-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {t("settings.title")}
        <IconButton aria-label={t("settings.closeSettings")} edge="end" onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default SettingsDialogShell;
